import { goTo } from '@/shared/modules/goto/goTo';

export default ({ app }, inject) => {
  app.$goTo = goTo;
  inject('goTo', goTo);
};
